const state = {
	university: {},
	universities: []
};

const mutations = {
	'SET_UNIVERSITY' (state, university) {
		state.university = university;
	},
	'SET_UNIVERSITIES' (state, universities) {
		state.universities = universities;
	}
};

const actions = {};

const getters = {
	university: state => {
		return state.university;
	},
	universities: state => {
		return state.universities.map((university) => {
			return {
				value: university.id,
				label: university.name_location
			};
		});
	},
	universityById: (state) => (universityId) => {
		return state.universities.find((university) => {
			return university.id === universityId;
		});
	}
};

export default {
	state,
	mutations,
	actions,
	getters
};
